export default {
    viewNoticeModal: {
        isOpen: false,
    },
    addNoticeModal: {
        isOpen: false,
    },
};
